var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'tsyringe';
let TaxDataSource = class TaxDataSource {
    // 源泉徴収額を取得
    loadWithholdingAmount(amount) {
        const json = require('../../../common/json/withholding.json');
        const withholdingList = json['data'];
        const equalMoreMax = withholdingList[withholdingList.length - 1].equalMore;
        const withholding = withholdingList.find((item) => (amount >= item.equalMore && amount <= item.equalLess) ||
            (amount >= item.equalMore && item.equalMore === equalMoreMax));
        if (withholding === undefined) {
            console.log('withholding is undefined');
            return 0;
        }
        return Math.floor(withholding.amount + (amount - withholding.rewardSubtract) * (withholding.rate / 100));
    }
};
TaxDataSource = __decorate([
    injectable()
], TaxDataSource);
export { TaxDataSource };
